import { Carousel as MantineCarousel, Embla } from '@mantine/carousel';
import { FC, useCallback, useState, useEffect } from 'react';
import { CarouselEpisodesProps } from './types';
import { EpisodeIframe } from '@molecules/frontoffice/EpisodeIframe';
import { useStyles } from './styles';

export const CarouselEpisodes: FC<CarouselEpisodesProps> = ({ episodes }) => {
  const { classes } = useStyles();

  const [embla, setEmbla] = useState<Embla | null>(null);

  const [isScrollable, setIsScrollable] = useState(false);

  const handleScroll = useCallback(() => {
    if (!embla) return;

    setIsScrollable(embla.canScrollNext());
  }, [embla]);

  useEffect(() => {
    if (embla) {
      embla.on('scroll', handleScroll);
      handleScroll();
    }
  }, [embla, handleScroll]);

  if (!episodes || episodes.length === 0) {
    return null;
  }

  return (
    <MantineCarousel
      mt={30}
      height={152}
      breakpoints={[
        { maxWidth: 'md', slideSize: '33%' },
        { maxWidth: 'sm', slideSize: '100%' },
      ]}
      role="region"
      align="start"
      aria-label="Carousel-episodes"
      getEmblaApi={setEmbla}
      nextControlLabel="next-carousel-button"
      previousControlLabel="previous-carousel-button"
      slideSize="25%"
      w="100%"
      slideGap="md"
      loop
      style={{ cursor: 'pointer' }}
      classNames={classes}
      withControls={
        episodes.length === 1 || episodes?.length < 4 ? false : isScrollable
      }
    >
      {episodes?.map((episode) => (
        <MantineCarousel.Slide key={episode.id}>
          <EpisodeIframe episode={episode} />
        </MantineCarousel.Slide>
      ))}
    </MantineCarousel>
  );
};
